import axios from "axios";
import { refreshSession } from "./authClient";

const API_BASE = process.env.REACT_APP_API_URL || "";

const apiClient = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                await refreshSession();
                return apiClient(originalRequest);
            } catch (refreshError) {
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export async function getAdminStats(signal) {
    const resp = await apiClient.get("/api/admin/stats", { signal });
    return resp.data;
}

export async function getAdminUsers(signal) {
    const resp = await apiClient.get("/api/admin/users", { signal });
    return resp.data;
}

export async function getAdminUserDetail(userId, signal) {
    const resp = await apiClient.get(`/api/admin/users/${userId}`, { signal });
    return resp.data;
}

export async function resyncUserTransactions(userId) {
    const resp = await apiClient.post(`/api/admin/users/${userId}/resync`);
    return resp.data;
}

export async function toggleFreeAccess(userId, enabled) {
    const resp = await apiClient.post(`/api/admin/users/${userId}/free-access`, { enabled });
    return resp.data;
}

export async function getSystemHealth(signal) {
    const resp = await apiClient.get("/api/admin/health", { signal });
    return resp.data;
}
